import { SearchQuery } from "../code/search-query/search-query";
import { buildSearchQuery, QueryFieldMapping } from "../code/search-query/query-mapper";
import { DataColumn } from "../controls/Data.default";
import { DynamicSchema } from "../controls/DynamicForm.default";

export interface EventsTypesViewForm {
  readonly name: string;
  readonly description: string;
  readonly code: string;
}

export const eventsTypesViewColumns: DataColumn[] = [
  {
    title: "Name",
    key: "name",
    width: 192,
    sort: true,
    defaultSort: "asc",
    fixed: "left",
  },
  {
    title: "Description",
    key: "description",
    width: 192,
    sort: true,
  },
  {
    title: "Code",
    key: "code",
    width: 192,
    sort: true,
  },
  {
    title: "Events",
    key: "totalEventsCount",
    width: 192,
    sort: true,
    type: "badge",
  },
];

const eventsTypesQueryMappings: QueryFieldMapping[] = [
  { formField: "name" },
  { formField: "description" },
  { formField: "code" },
];

export const mapEventsTypesViewQuery = (values: EventsTypesViewForm): SearchQuery =>
  buildSearchQuery(values, eventsTypesQueryMappings);

export const eventsTypesSearchSchema: DynamicSchema = {
  groups: [
    {
      controls: [
        { type: "textbox", name: "name", label: "Name" },
        { type: "textbox", name: "description", label: "Description" },
        { type: "textbox", name: "code", label: "Code" },
      ],
    },
  ],
};
